<template>
  <a-spin :spinning="loading">
    <a-row :gutter="16">
      <a-col :span="18">
        <div class="card">
          <div class="card-header">
            <div class="card-header-element-wrapper">
              <h5><strong>Existing members</strong></h5>
              <a-button type="primary" disabled
                >Upload new MRF version</a-button
              >
            </div>
          </div>
          <div class="card-body">
            <div style="text-align: center;">
              <a-table
                :columns="columns"
                :data-source="dataSource"
                :pagination="{ pageSize: 50 }"
                :row-key="(record) => record.id"
              >
                <span slot="actions" slot-scope="record">
                  <a-space :space="16">
                    <a-popconfirm
                      title="Are you sure you want to delete this member?"
                      ok-text="Yes"
                      cancel-text="No"
                      @confirm="deleteMember(record.id)"
                      ><a
                        ><i
                          class="fe fe-trash font-size-15 align-middle text-gray-6"
                          title="Delete"
                      /></a>
                    </a-popconfirm>
                  </a-space>
                </span>

                <span slot="active" slot-scope="text">
                  <a-tag :color="text === 0 ? 'volcano' : 'green'">
                    {{ text === 0 ? 'INACTIVE' : 'ACTIVE' }}
                  </a-tag>
                </span>
              </a-table>
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="card">
          <div class="card-header">
            <h5><strong>Add new member</strong></h5>
          </div>
          <div class="card-body">
            <a-form-item label="EPEX Short Name">
              <a-input v-model="epexName" style="width: 100%;"></a-input>
            </a-form-item>
            <a-form-item label="EIC Code">
              <a-input v-model="eicCode" style="width: 100%;"></a-input>
            </a-form-item>
            <a-form-item>
              <a-button class="btn btn-success btn-block" @click="createMember"
                ><i
                  class="fe fe-plus-circle font-size-15"
                  title="Add participant"
                  style="margin-right: 10px;"
                />
                Add member
              </a-button>
            </a-form-item>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>
import Vue from 'vue'
import { Space } from 'ant-design-vue'
Vue.use(Space)
import { EpexService } from '@/services/api'

const columns = [
  {
    title: 'EPEX Short name',
    dataIndex: 'epex_name',
  },
  {
    title: 'EIC Code',
    dataIndex: 'eic_code',
  },
  {
    title: 'Actions',
    scopedSlots: { customRender: 'actions' },
  },
]

export default {
  components: {},
  data() {
    return {
      columns: columns,
      dataSource: [],
      name: null,
      loading: false,
      epexName: '',
      eicCode: '',
    }
  },
  methods: {
    async deleteMember(id) {
      await EpexService.deleteMember(id)
      this.fetchMembers()
    },
    async createMember() {
      await EpexService.createMember(this.epexName, this.eicCode)
      this.epexName = ''
      this.eicCode = ''
      this.fetchMembers()
    },
    async fetchMembers() {
      this.loading = true
      const response = await EpexService.getMembers()
      this.dataSource = response.data.data
      this.loading = false
    },
  },
  mounted() {
    this.fetchMembers()
  },
}
</script>

<style scoped>
.card-header-element-wrapper {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
}
</style>
